import React from 'react'
import './Committee.css'
import user from '../../assets/images/user.webp'
import NarayanRao from '../../assets/images/secertary.webp'
import Sadagopan from '../../assets/images/sadagopan2.webp'
import Vidyashankar from '../../assets/images/vs.webp'
import Ashok from '../../assets/images/ashokmanaay.png'
import dd from '../../assets/images/Prof. T J Ramamurthy.jpg'
import adddean from '../../assets/images/Dr. S.Y Kulkarni.jpg'
import Eishwar from '../../assets/images/Prof.Eishwar Maanay.jpg'
import principal from '../../assets/images/Dr. Krishnamurthy G N.jpg'
import ecehod from '../../assets/images/Dr. Yasha Jyothi M Shirur.jpg'
import eeehod from '../../assets/images/Dr. Venkatesha K7.jpg'
import jyoti from '../../assets/images/Dr. Jyoti R Munavalli.jpg'
import bindu from '../../assets/images/Dr. Bindu S.jpg'
import Raksha from '../../assets/images/Mrs.-Raksha-S.webp'
import Prathyusha from '../../assets/images/Mrs. Prathyusha Pasupuleti.jpg'
import priyashree from '../../assets/images/Dr. Priyashree S7.jpg'
import keerti from '../../assets/images/Dr. Keerti Kulkarni.jpg'

import shubha from '../../assets/images/Dr. Shubha Rao K7.jpg'
import Charithra from '../../assets/images/Dr. Charithra C M.jpg'
import subodh from '../../assets/images/Dr. Subodh Kumar Panda.jpg'
import manjunath from '../../assets/images/Dr. Manjunath G. Asuti.jpg'
import rekha from '../../assets/images/Dr. Rekha P.jpg'
import bhuvana from '../../assets/images/Dr. Bhuvana Suganthi D.jpg'
import ashwini from '../../assets/images/Dr. Ashwini S. Savanth.jpg'
import karnam from '../../assets/images/Mrs. Karanam Vasudha9.jpg'

import madhu from '../../assets/images/Dr. Madhu S10.jpg'

import Shruti from '../../assets/images/Mrs.-Shruti-V-joshi.webp'

import saritha from '../../assets/images/Dr.Saritha Chakrasali.jpg'
import sateesh from '../../assets/images/slsateesh.webp'
import vrunda from '../../assets/images/Dr. Vrunda Kusanur.jpg'
import champa from '../../assets/images/Dr. Champa P N6.jpg'
import Sumathi from '../../assets/images/Mrs. Sumathi A.jpg'
import kiran from '../../assets/images/Mr. Kiran K N.jpg'
import kruthi from '../../assets/images/Mrs. Kruthi Jayaram9.jpg'
import priyadarshini from "../../assets/images/Dr. Priyadarshini K Desai.jpg"
import rashmi from '../../assets/images/Dr. Rashmi S. Bhaskar.jpg'
import smitha from '../../assets/images/Dr. Smitha Gayathri D.jpg'
import Kumar from '../../assets/images/Dr.-A-Kumar.webp'
import sujaya from '../../assets/images/Dr. Sujaya B.L.jpg'
import sujith from '../../assets/images/Mr. Sujith T6.jpg'
import sunitha from '../../assets/images/Dr. Sunitha S V.jpg'
import Srihari from '../../assets/images/Dr. Srihari.jpg'
import Tejaswini from '../../assets/images/Dr. Tejaswini R Murgod.jpg'
import Halaharvi from '../../assets/images/Dr. Halaharvi Keerthi.jpg'
import Lakshmi from '../../assets/images/Dr. Laxmi V.jpg'
import priya from '../../assets/images/Dr. Priya R Sankpal.jpg'
import sarala from '../../assets/images/Mrs. Sarala T.jpg'
 import shadakshari from '../../assets/images/Mr. Shadakshari.jpg'
import AshwiniA from '../../assets/images/Mrs. Ashwini A8.jpg'
import manju from '../../assets/images/Dr Manju Devi.jpg'
import umareddy from '../../assets/images/Dr Uma Reddy.jpg'
import umavathi from '../../assets/images/Dr Umavathi.jpg'
import anushree from '../../assets/images/anushree.webp'
import premkumar from '../../assets/images/Dr Premkumar.jpg'
import roopanayak from '../../assets/images/Dr Roopa Nayak.jpg'
import chandrashekar from '../../assets/images/Dr Chandrashekar.jpg'


const Committee = () => {
    return (
        <div className="Committee">
            <h1 className="ch">Chairs</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <div className="container">
                    <h2 className="he">Chief Patron</h2>
                    <div className="content">
                        <div className="card">
                            <div className="card-content">
                                <div className="image">
                                    <img src={NarayanRao} alt="" />
                                </div>
                                <div className="name-profession">
                                    <span className="name">Sri. Narayan Rao R. Maanay</span>
                                    <span className="profession">Chairman, Governing Body, BNM Institute of Technology, Bengaluru</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Chief Mentor</h2>
                    <div className="content">

                        <div className="card">
                            <div className="card-content">
                                <div className="image">
                                    <img src={Sadagopan} alt="" />
                                </div>


                                <div className="name-profession">
                                    <span className="name">Dr. S. Sadagopan</span>
                                    <span className="profession">Former Director, IIIT Bangalore, Advisor, BNMIT</span>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Patrons</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Vidyashankar} alt="" />
                                    </div>


                                    <div className="name-profession">
                                        <span className="name">Dr.S.Vidyashankar</span>
                                        <span className="profession">Vice Chancellor, Belagavi, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Ashok} alt="" />
                                    </div>


                                    <div className="name-profession">
                                        <span className="name">Sri. Ashok R. Maanay</span>
                                        <span className="profession">Joint-Secretary, BNMEI, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={dd} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Prof. T.J. Rama Murthy</span>
                                        <span className="profession">Director, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">

                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={adddean} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. S. Y. Kulkarni</span>
                                        <span className="profession">Additional Director & Principal, BNMIT, Bengaluru, India</span>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Eishwar} alt="" />
                                    </div>



                                    <div className="name-profession">
                                        <span className="name">Prof. Eishwar N. Maanay</span>
                                        <span className="profession">Dean, BNMIT, Bengaluru, India</span>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={principal} alt="" />
                                    </div>
                                    <div className="name-profession">
                                        <span className="name">Dr. Krishnamurthy G. N.</span>
                                        <span className="profession">Deputy Director, BNMIT, Bengaluru, India</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Steering Committee</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={adddean} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. S. Y. Kulkarni</span>
                                        <span className="profession">Additional Director & Principal, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

            
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">General Chairs</h2>
                    <div className="team">
                    
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={eeehod} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Venkatesha K.</span>
                                        <span className="profession">Prof & HoD, EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ecehod} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Yasha Jyothi M. Shirur</span>
                                        <span className="profession">Prof & HoD, ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Organizing Chairs</h2>
                    <div className="team">
                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyashree} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyashree S</span>
                                        <span className="profession">Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                     
                    <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bindu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bindu S.</span>
                                        <span className="profession">Head-Research & Development<br/>
                                            Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                       
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Technical Program Committee</h2>
                    <div className="team">
                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={madhu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Madhu S.</span>
                                        <span className="profession">Chair, Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={rekha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rekha P.</span>
                                        <span className="profession">Chair, Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                          <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Srihari} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name" >Dr. Srihari Gude.</span>
                                        <span className="profession" style={{fontSize:'15px'}}>Co-Chair, Assoc.Prof., Dept. of EEE, Christ University.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Kumar} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. A. Kumar</span>
                                        <span className="profession">Co-Chair, Professor, EEE, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={champa} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Champa. P. N.</span>
                                        <span className="profession">Co-Chair, Asso Prof., EEE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={bhuvana} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Bhuvana Suganthi D.</span>
                                        <span className="profession">Co-Chair,Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                 
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Charithra} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Charithra C M.</span>
                                        <span className="profession">Co-Chair, Asso.Prof., MBA, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Profile 1 */}
<div className="content">
  <div className="card">
    <div className="card-content">
      <div className="image">
        <img src={manju} alt=""/>
      </div>
      <div className="name-profession">
        <span className="name">Dr. Manju Devi</span>
        <span className="profession">Prof. & Head, ECE Dept., The Oxford College of Engineering, Bengaluru</span>
      </div>
    </div>
  </div>
</div>


<div className="content">
  <div className="card">
    <div className="card-content">
      <div className="image">
        <img src={umareddy} alt="" />
      </div>
      <div className="name-profession">
        <span className="name">Dr. N V Uma Reddy</span>
        <span className="profession"> Professor & Dean, Computer Science & Engineering, New Horizon College of Engineering, Bengaluru</span>
      </div>
    </div>
  </div>
</div>

{/* Profile 5 */}
<div className="content">
  <div className="card">
    <div className="card-content">
      <div className="image">
        <img src={umavathi} alt="" />
      </div>
      <div className="name-profession">
        <span className="name">Dr. M Umavathi</span>
        <span className="profession">Associate Professor, EEE, BMSCE, Bengaluru</span>
      </div>
    </div>
  </div>
</div>

{/* Profile 6 */}
<div className="content">
  <div className="card">
    <div className="card-content">
      <div className="image">
        <img src={premkumar} alt="" />
      </div>
      <div className="name-profession">
        <span className="name">Dr. Premkumar M</span>
        <span className="profession">Professor & Head, EEE Dept., DSCE, Bengaluru</span>
      </div>
    </div>
  </div>
</div>

{/* Profile 7 */}
<div className="content">
  <div className="card">
    <div className="card-content">
      <div className="image">
        <img src={roopanayak} alt="" />
      </div>
      <div className="name-profession">
        <span className="name">Dr. Roopa Nayak</span>
        <span className="profession">Associate Professor & Head, EEE Dept., RNSIT, Bengaluru</span>
      </div>
    </div>
  </div>
</div>

{/* Profile 8 */}
<div className="content">
  <div className="card">
    <div class="card-content">
      <div className="image">
        <img src={chandrashekar} alt="" />
      </div>
      <div className="name-profession">
        <span className="name">Dr.Chandrashekar M J</span>
        <span className="profession">Professor & Head, EEE Dept., SJBIT, Bengaluru</span>
      </div>
    </div>
  </div>
</div>

                        
                        

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={ashwini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Ashwini S. Savanth</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
<div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={vrunda} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Vrunda Kusanur</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                          <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={rashmi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Rashmi S Bhaskar</span>
                                        <span className="profession">Asso.Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={smitha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Smitha Gayathri D</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sujaya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Sujaya B L</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                          <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Tejaswini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr.Tejaswini R Murgod</span>
                                        <span className="profession" style={{fontSize:'15px'}}>Prof.,Dept. of AIML, BNMIT, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Halaharvi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Halaharvi Keerthi</span>
                                        <span className="profession" style={{fontSize:'15px'}}>Asso.Prof.,Dept. of AIML, BNMIT, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Lakshmi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Laxmi V</span>
                                        <span className="profession">Asso.Prof., ISE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                         
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={anushree} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Anushree Ramanath</span>
                                        <span className="profession" style={{ fontSize: '12px' }}>Co-Chair for EE Stream, Technical Leader in Sustainability, Schnider Electric, San
                                            Francisco</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       



                       

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Financial Chairs</h2>
                    <div className="team">
                   

                       
                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={madhu} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Madhu S.</span>
                                        <span className="profession">Asso.Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={manjunath} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Manjunath G. Asuti</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Raksha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Raksha S</span>
                                        <span className="profession">Assistant Professor, EEE, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    

                    

                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Publication Committee</h2>
                    <div className="team">

             <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={shubha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Shubha Rao.K </span>
                                        <span className="profession" style={{}}>Chair, Asso.Prof.,EEE, BNMIT Bengaluru,
                                            India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                  

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={jyoti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Jyoti R. Munavalli</span>
                                        <span className="profession">Chair, Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priya} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priya R Sankpal</span>
                                        <span className="profession">Co-Chair, Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                           <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={keerti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Keerti Kulkarni</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={priyadarshini} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Priyadarshini K Desai</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       


                        
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Sumathi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Sumathi A.</span>
                                        <span className="profession">Asst Prof., ECE,
                                            BNMIT, Bengaluru, India.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                     

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={AshwiniA} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Ashwini A</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                           <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={kruthi} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Kruthi Jayaram</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Shruti} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Shruti V Joshi</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sarala} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Sarala T</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Prathyusha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Prathyusha Pasupuleti</span>
                                        <span className="profession">Asst Prof., Dept. of MBA, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="container">
                    <h2 className="he">Information Chairs</h2>
                    <div className="team">

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sujith} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Sujith T</span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                      

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={kiran} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Kiran K.N</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={karnam} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Karnam Vasudha </span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={shadakshari} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mr. Shadakshari</span>
                                        <span className="profession">Asst Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                      
                    </div>
                </div>

                <div className="container">
                    <h2 className="he">Sponsorship Committee Chairs</h2>
                    <div className="team">
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={saritha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Saritha Chakrasali</span>
                                        <span className="profession">Head, T & P, Professor, ISE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={sateesh} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Prof. S. L. Sateesh Kumar</span>
                                        <span className="profession">Head, Teaching Learning Centre, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       {/* <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={vrunda} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Vrunda Kusunur</span>
                                        <span className="profession">Asso.Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={subodh} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Dr. Subodh Kumar Panda</span>
                                        <span className="profession">Prof., ECE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={karnam} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Smt. Karnam Vasudha </span>
                                        <span className="profession">Asst Prof., EEE, BNMIT, Bengaluru, India</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <div className="content">
                            <div className="card">
                                <div className="card-content">
                                    <div className="image">
                                        <img src={Raksha} alt="" />
                                    </div>

                                    <div className="name-profession">
                                        <span className="name">Mrs. Raksha S</span>
                                        <span className="profession">Assistant Professor, EEE, BNM Institute of Technology, Bengaluru</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                       

                       
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', padding: '1rem' }}>
                <h2 className="he" style={{ marginTop: "40px" }}>Organizing Committee</h2>

                <ul className="liste">
              
  <li><strong>Dr. Chayadevi M.L.</strong>, Prof & HoD, CSE, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. S. Srividhya</strong>, Prof & HoD, ISE, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. Sheba Selvam</strong>, Prof & HoD, AIML, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. L. Venkata Reddy</strong>, Prof & HoD, Mathematics, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. K. N. N. Prasad</strong>, Prof & HoD, Physics, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. Prathibha B. S.</strong>, Prof & HoD, Chemistry, BNMIT, Bengaluru, India.</li>
  <li><strong>Dr. Mukund Sharma</strong>, Prof & HoD, Dept. of MBA, BNMIT, Bengaluru, India.</li>
  <li><strong>Smt. Pankaja H G</strong>, Assistant Professor, EEE, BNMIT, Bengaluru, India.</li>
  <li><strong>Smt. Kurva Swetha</strong>, Assistant Professor, EEE, BNMIT, Bengaluru, India.</li>
  <li><strong>Mr. Sudharshan</strong>, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
  <li><strong>Smt. Arpita Kulkarni</strong>, Assistant Professor, ECE, BNMIT, Bengaluru, India.</li>
</ul>
            
                    
              <h2 className="he" style={{ marginTop: "40px" }}>
  Advisory Board Members
</h2>

<ul className="liste">
  <li><strong>Dr. Anish Cheriyan</strong>, Vice President, Test (Intelligent Cockpit), Harman Automotive & Chair, IEEE VTS Bangalore Chapter.</li>

  <li><strong>Dr. Chengappa M R</strong>, Chair-Elect, IEEE Bangalore Section, Telco Core & Cloud Native Architect, Hewlett Packard Enterprise, Bengaluru.</li>

  <li><strong>Dr. Navin Kumar</strong>, Professor, Department of Electronics & Communication, Amrita School of Engineering, Bengaluru & Past Chair, IEEE VTS Bangalore Chapter.</li>

  <li><strong>Dr. Priyaranjan Mishra</strong>, Advisor, C-DAC Bengaluru, National Supercomputing Mission (Power Supply to Next Gen Rudra Servers), Past Chair, IEEE SSIT Bangalore Chapter.</li>

  <li><strong>Dr. Omid Ansari</strong>, Penn State University, USA.</li>

  <li><strong>Dr. Sheldon Williamson</strong>, Professor, Electrical, Computer and Software Engineering; Canada Research Chair in Electric Energy Storage Systems for Transportation Electrification; Senior Member – IEEE; Associate Editor for IEEE Transactions and Journals.</li>

  <li><strong>Sri. Srikanth Korse</strong>, R & D Engineer, Fraunhofer IIS & RWTH Aachen University, Germany.</li>

  <li><strong>Sri. Vikas Vijaya Kumar</strong>, R & D Engineer, Tape-out Specialist, Stein bei Nürnberg, Bavaria, Germany.</li>

  <li><strong>Dr. Neelabh Kashyap</strong>, Principal Data Scientist, KONE, Finland.</li>

  <li><strong>Sri. Ramesh Chinta</strong>, Principal Member-Technical Staff, AT&amp;T, USA.</li>

  <li><strong>Sri. Samuel Tensingh</strong>, Associate Lecturer, University of Sydney, Australia.</li>

  <li><strong>Dr. Shyam Vasudeva Rao</strong>, Founder & Director, Renalyx Health Systems, Forus & Rx DHP, Bengaluru.</li>

  <li><strong>Dr. Riyaz A R</strong>, Manager, Application Engineering, CoreEL Technologies, Bengaluru.</li>

  <li><strong>Dr. Shivananda Koteshwar</strong>, Vice President & EDA Group Head South Asia, Synopsys, Bengaluru.</li>

  <li><strong>Dr. Sanjeevikumar Padmanaban</strong>, Co-Chair for EE Stream, SMIEEE, Professor, Department of EE, IT & Cybernetics, University of South-Eastern Norway.</li>

  <li><strong>Dr. Sainarayanan Gopalakrishnan</strong>, Technology Director, HCL Technologies, Chennai.</li>

  <li><strong>Dr. Anand S</strong>, Director, Postgraduate Studies, Research & Innovation Department, College of Banking & Financial Studies, Muscat, Oman.</li>

  <li><strong>Sri. Mahesh Devagiri</strong>, Director & Co-Founder, Nyxses India Pvt Ltd, Bengaluru.</li>

</ul>
            </div>
        </div>
    )
}

export default Committee